/**
 * Validação se o utilizador
 * pode fazer uma determinada ação nome
 * software. Caso não existe uma permissão
 * predefinida para uma determinada acção, ele
 * poderá fazer, se não irá validar esse permissão.
 *
 * @since 1.0.0
 * @category Getter
 * @autor Tiago Martinho
 *
*/
const can = ( state, rootState ) => ( model, type ) => {
    if ( !state.can[model] || !state.can[model][type] )
        return true;

    return state.can[model][type].some( role => [ rootState.getRole, 'any' ].includes( role ) );
};

export default {
    can
};